<template>
  <div class="card-usage">
    <div class="card-content">
      <span class="paragraph-20-weight300">{{ text }}</span>
      <span class="fontSize20 card-value" :class="colorClass">{{ value | formatNumberZero }} %</span>
    </div>
    <div class="progress-bar">
      <div 
        class="progress-fill" 
        :class="colorClass"
        :style="{ width: `${value}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardUsage",
  props: ["text", "value"],
  computed: {
    colorClass() {
      if (this.value > -1 && this.value < 26) return 'color-green';
      if (this.value >= 26 && this.value < 51) return 'color-yellow';
      if (this.value >= 51 && this.value < 76) return 'color-orange';
      if (this.value >= 76) return 'color-red';
      return '';
    }
  },
};
</script>

<style scoped>
.card-usage {
  border-radius: 0.25rem;
  padding: 1rem 1.25rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 1rem;
  background-color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #e0e0e0;
}

.card-usage:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.progress-bar {
  height: 6px;
  background-color: #eaeaea;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.5s ease-out;
}

/* Classes de cores para texto e barra */
.color-green {
  color: #009933;
}
.progress-fill.color-green {
  background-color: #009933;
}

.color-yellow {
  color: #ffcc00;
}
.progress-fill.color-yellow {
  background-color: #ffcc00;
}

.color-orange {
  color: #ff6600;
}
.progress-fill.color-orange {
  background-color: #ff6600;
}

.color-red {
  color: #db2511;
}
.progress-fill.color-red {
  background-color: #db2511;
}
</style>
